module.exports = __webpack_public_path__ + "img/直播banner04.986f86bb.png";